import { render, staticRenderFns } from "./ScriptEditor.vue?vue&type=template&id=194c5920&"
import script from "./ScriptEditor.vue?vue&type=script&lang=ts&"
export * from "./ScriptEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ScriptEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports